import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from "react";
import { StyledBoardsCarouselComponent } from "./boards-carousel-component.scss";
import StoriesSlickCarouselComponent from "/components/core/community/home/stories-slick-carousel/stories-slick-carousel-component";
import colors from "/styles/colors";
import LeftArrow from "/static/svg/arrow-left-no-fill.svg";
import RightArrow from "/static/svg/arrow-right2.svg";
import VisibilitySensor from "react-visibility-sensor";
import { XS } from "constants/vp-sizes";
import { isMobile } from "/utils/mobile";
import { fixDevImageUrl } from "/services/community/url-service";
import { trackEvent } from "/services/bigbrain-service";
import { CAROUSEL_SWITCH_BOARD_CLICKED } from "/constants/bigbrain-event-types";
import CarouselRoundArrowComponent from "/components/core/carousel-arrow/carousel-round-arrow-component";
import classnames from "classnames";
import BoardsCarouselItemComponent from "./boards-carousel-item/boards-carousel-item-component";
const mod = (x, y)=>{
    return (x % y + y) % y;
};
class BoardsCarouselComponent extends Component {
    onVisibilityChange(visible, data) {
        const { stopAutoSlide, startAutoSlide } = this.props;
        if (stopAutoSlide && startAutoSlide) {
            visible ? stopAutoSlide() : startAutoSlide();
        }
    }
    renderItem(item, index) {
        const { aboveTheFold } = this.props;
        const url = fixDevImageUrl(item.boardImage);
        const borderColor = !isMobile() ? colors[item.color] : "none";
        return /*#__PURE__*/ _jsx(BoardsCarouselItemComponent, {
            index: index,
            url: url,
            borderColor: borderColor,
            item: item,
            onClick: this.onItemClick,
            aboveTheFold: aboveTheFold
        }, index);
    }
    onCarouselMounted(el) {
        this._carousel = el;
    }
    onLeftClick() {
        const { changing } = this.state;
        if (changing) return;
        const { setActive, active, quotes } = this.props;
        const nextActive = mod(active - 1, quotes.length);
        trackEvent(CAROUSEL_SWITCH_BOARD_CLICKED, {
            kind: "quotesArrow"
        });
        setActive(nextActive);
    }
    onRightClick() {
        const { changing } = this.state;
        if (changing) return;
        const { setActive, active, quotes } = this.props;
        const nextActive = mod(active + 1, quotes.length);
        trackEvent(CAROUSEL_SWITCH_BOARD_CLICKED, {
            kind: "quotesArrow"
        });
        setActive(nextActive);
    }
    beforeChange(prevIndex, nextIndex) {
        const { setActive, active } = this.props;
        this.currentActiveSlide = nextIndex;
        if (!isMobile() && active != nextIndex) {
            setActive(nextIndex);
        }
    }
    slideTo(prev, current) {
        const n = this.props.quotes.length;
        if (!this._carousel) return;
        if (current == (prev + 1) % n) {
            this._carousel.slickNext();
        } else if (current == ((prev - 1) % n + n) % n) {
            this._carousel.slickPrev();
        } else {
            this._carousel.slickGoTo(current);
        }
    }
    onItemClick(itemIndex) {
        const { active } = this.props;
        trackEvent(CAROUSEL_SWITCH_BOARD_CLICKED, {
            kind: "boardClicked"
        });
        this.slideTo(active, itemIndex);
    }
    shouldComponentUpdate(nextProps) {
        const { active, showNavigationArrows } = nextProps;
        return this.currentActiveSlide !== active || showNavigationArrows !== this.props.showNavigationArrows;
    }
    componentDidUpdate(prevProps) {
        const prev = prevProps.active;
        const current = this.props.active;
        this.slideTo(prev, current);
    }
    multipleQuotes() {
        const { quotes } = this.props;
        if (!quotes) return false;
        return quotes.length > 1;
    }
    render() {
        const { quotes, active, showNavigationArrows, removeBoardBorder, aboveTheFold } = this.props;
        const renderNavigationArrows = this.multipleQuotes() && showNavigationArrows;
        const showBoardsArrows = this.multipleQuotes() && !showNavigationArrows;
        return /*#__PURE__*/ _jsx(StyledBoardsCarouselComponent, {
            className: "boards-carousel-component",
            children: /*#__PURE__*/ _jsxs("div", {
                className: classnames("boards-carousel-frame", {
                    "remove-border": removeBoardBorder,
                    "above-the-fold": aboveTheFold
                }),
                children: [
                    /*#__PURE__*/ _jsx(StoriesSlickCarouselComponent, {
                        autoplay: false,
                        items: quotes,
                        renderItem: this.renderItem,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: false,
                        onCarouselMounted: this.onCarouselMounted,
                        initialSlide: active,
                        variableWidth: false,
                        active: true,
                        speed: 800,
                        minWidthForCarousel: XS,
                        beforeChange: this.beforeChange,
                        arrows: showBoardsArrows,
                        centerMode: true,
                        nextArrow: /*#__PURE__*/ _jsx(CarouselRoundArrowComponent, {}),
                        prevArrow: /*#__PURE__*/ _jsx(CarouselRoundArrowComponent, {})
                    }),
                    renderNavigationArrows && /*#__PURE__*/ _jsxs("div", {
                        className: "custom-arrows",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "custom-arrow left-arrow",
                                onClick: this.onLeftClick,
                                children: /*#__PURE__*/ _jsx(LeftArrow, {})
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "custom-arrow right-arrow",
                                onClick: this.onRightClick,
                                children: /*#__PURE__*/ _jsx(RightArrow, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(VisibilitySensor, {
                        partialVisibility: false,
                        onChange: this.onVisibilityChange,
                        active: true,
                        scrollCheck: true,
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "stop-area"
                        })
                    })
                ]
            })
        });
    }
    constructor(props){
        super(props);
        this.state = {};
        this.onCarouselMounted = this.onCarouselMounted.bind(this);
        this.beforeChange = this.beforeChange.bind(this);
        this.renderItem = this.renderItem.bind(this);
        this.onItemClick = this.onItemClick.bind(this);
        this.onLeftClick = this.onLeftClick.bind(this);
        this.onRightClick = this.onRightClick.bind(this);
        this.onVisibilityChange = this.onVisibilityChange.bind(this);
    }
}
export { BoardsCarouselComponent as default };
BoardsCarouselComponent.defaultProps = {
    showNavigationArrows: true,
    removeBoardBorder: false
};
